import { Grid, Typography } from '@mui/material';
import { FunctionField, SimpleShowLayout, TextField, useRecordContext } from 'react-admin';
import { FinancialAssets } from 'src/lib';
import { Account, AccountFinancialInvestmentExperienceType } from 'src/models';

export const InvestmentExperience = ({
  title,
  experience,
}: {
  title: string;
  experience?: AccountFinancialInvestmentExperienceType;
}) => {
  return (
    <>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={12}>
            <SimpleShowLayout>
              <Typography variant='body1'>{title}</Typography>
            </SimpleShowLayout>
          </Grid>
          <Grid item sm={6}>
            <SimpleShowLayout>
              <FunctionField
                render={(record: AccountFinancialInvestmentExperienceType) => (
                  <Typography variant='body2'>{record.yearsOfExperience?.label ?? 'NA'}</Typography>
                )}
                record={experience}
                label='Years of Experience'
              />
            </SimpleShowLayout>
          </Grid>
          <Grid item sm={6}>
            <SimpleShowLayout>
              <FunctionField
                render={(record: AccountFinancialInvestmentExperienceType) => (
                  <Typography variant='body2'>{record.tradesPerYear?.label ?? 'NA'}</Typography>
                )}
                record={experience}
                label='Trades per Year'
              />
            </SimpleShowLayout>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export const SuitabilityInformationShow = () => {
  const record = useRecordContext<Account>();

  return (
    <Grid container direction='row'>
      {record.financialAssets && <FinancialAssets record={record} />}
      <Grid item md={12}>
        <SimpleShowLayout>
          <Typography variant='h6'>Liquidity Needs</Typography>
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField source='suitabilityInformation.liquidityNeeds.label' label='Liquidity Needs' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField source='suitabilityInformation.investmentObjectives.label' label='Investment Objectives' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField source='suitabilityInformation.riskTolerance.label' label='Risk Tolerance' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField source='suitabilityInformation.timeHorizon.label' label='Time Horizon' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={12}>
        <SimpleShowLayout>
          <Typography variant='h6'>Investment Experience</Typography>
        </SimpleShowLayout>
      </Grid>
      <InvestmentExperience
        title='Stocks'
        experience={record?.suitabilityInformation?.financialInvestmentExperience?.stocks}
      />
      <InvestmentExperience
        title='Bonds'
        experience={record?.suitabilityInformation?.financialInvestmentExperience?.bonds}
      />
      <InvestmentExperience
        title='Commodities'
        experience={record?.suitabilityInformation?.financialInvestmentExperience?.commodities}
      />
      <InvestmentExperience
        title='Options'
        experience={record?.suitabilityInformation?.financialInvestmentExperience?.options}
      />
      <InvestmentExperience
        title='Margins'
        experience={record?.suitabilityInformation?.financialInvestmentExperience?.margins}
      />
    </Grid>
  );
};
